module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADnSURBVHgB7ZS9DcIwEIXvEAV0jHIjMApdRMUIcTagg1QZBUZgGwJImPMlCjHC9qVIESmvys+791l28hCUotPdwAJzuXnb4rZfG83cAkbWDJgBIwL4u99RZTeQkPPQuT4MAlD5yPmnquD1vMQg8o49gHCUGQ2AV74FsEZurKUQpAt3nsZsmtkEgCvgyuaie9BCAPELcddeuBiLZtYXQkBUcvcA5qASh2f/uwljYzpIODwJSEPi4SpAGJIOF4D0fKtYx/uQeHg/E6msbQfIVoozcb74yvuZSxggzZb8avpl553BGJr+Fn0A6jZ28X3b1WkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/download.png
// module id = qDSv
// module chunks = 0